import { PinoutDetailTable } from './pinout-detail-table.js';

import type { RequirementInstanceResult } from '@cadstrom/sigma-engine-shared';
import type { GridRowModel } from '@mui/x-data-grid-premium';

interface PinoutDetailPanelProps {
	row: GridRowModel<RequirementInstanceResult>;
	loading?: boolean;
	handleAddModuleFilter: (moduleReferenceDesignator: string) => void;
}

/**
 * Legacy detail-panel shim for Pinout. Guards the discriminated `instanceMetadata`
 * / `resultMetadata` shapes and forwards to {@link PinoutDetailTable}, which both
 * the V1 panel and V2 activity-timeline payload renderer mount.
 */
export function PinoutDetailPanel({ row, loading = false, handleAddModuleFilter }: PinoutDetailPanelProps) {
	if (!row.instanceMetadata || row.instanceMetadata.type !== 'PinoutValidationResult') {
		throw new Error(`Invalid row instance metadata type for PinoutDetailPanel: ${row.instanceMetadata?.type}`);
	}

	if (!row.resultMetadata || row.resultMetadata.type !== 'PinoutValidationResult') {
		throw new Error(`Invalid row result metadata type for PinoutDetailPanel: ${row.resultMetadata?.type}`);
	}

	return (
		<PinoutDetailTable
			instanceMetadata={row.instanceMetadata}
			resultMetadata={row.resultMetadata}
			loading={loading}
			handleAddModuleFilter={handleAddModuleFilter}
		/>
	);
}
